import * as React from "react";
import { Box, SvgIcon, Stack, Typography, Avatar } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export default function StatusView({ title, total, icon, bgColor }) {
  return (
    <Card>
      <CardContent>
        <Stack
          alignItems="flex-end"
          direction="row"
          justifyContent="space-between"
          spacing={2}
        >
          <Typography
            color="grey"
            variant="subtitle1"
            fontWeight="thin"
            textTransform="uppercase"
          >
            {title}
          </Typography>
          <Avatar
            sx={{
              backgroundColor: bgColor,
              height: 32,
              width: 32,  
            }}
          >
            <SvgIcon>{icon}</SvgIcon>
          </Avatar>
        </Stack>

        <Box display="flex" alignItems="center">
          <Typography variant="h4" fontWeight="thin">
            {total}
          </Typography>
          <Typography ml={1}></Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
